var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001---Surveillance-Magnifying-Glass",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m51 26c.007298 5.9424729-2.1101192 11.6917749-5.97 16.21-.8582964 1.0182992-1.8017008 1.9617036-2.82 2.82-8.9373669 7.6119662-21.9672451 7.9799583-31.3199804.8845442-9.35273523-7.0954141-12.50863924-19.7426831-7.58586149-30.4003009 4.92277774-10.65761781 16.59800859-16.45435213 28.06380809-13.93363797 11.4657994 2.52071416 19.6332059 12.67977987 19.6320338 24.41939467z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m47 26c.004269 9.8956851-6.9032509 18.4503694-16.5777569 20.5308824-9.6745061 2.080513-19.4881127-2.8782749-23.5522431-11.9008824-1.23487654-2.7093191-1.87262923-5.6525307-1.87-8.63.01267598-11.5927251 9.4072749-20.98732402 21-21 2.9774693-.00262923 5.9206809.63512346 8.63 1.87 7.5276023 3.3879597 12.3690114 10.8751187 12.37 19.13z",
    fill: "#90bae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m36.5 15.5c-.012676 11.5927251-9.4072749 20.987324-21 21-2.9774693.0026292-5.92068087-.6351235-8.63-1.87-1.23487654-2.7093191-1.87262923-5.6525307-1.87-8.63.01267598-11.5927251 9.4072749-20.98732402 21-21 2.9774693-.00262923 5.9206809.63512346 8.63 1.87 1.2348765 2.70931913 1.8726292 5.6525307 1.87 8.63z",
    fill: "#b0d3f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m26 41c-13 0-21-15-21-15s8-15 21-15 21 15 21 15-8 15-21 15z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m58.12 58.12c-.5617198.5632738-1.3245087.8798486-2.12.8798486s-1.5582802-.3165748-2.12-.8798486l-7-7c-1.1014354-1.182039-1.0689355-3.0240389.0735128-4.1664872s2.9844482-1.1749482 4.1664872-.0735128l7 7c1.1698135 1.1712702 1.1698135 3.0687298 0 4.24z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m48.83 46.01c-1.5221615.0820518-2.7379482 1.2978385-2.82 2.82l-3.8-3.8c1.0182992-.8582964 1.9617036-1.8017008 2.82-2.82z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26,
    cy: 26,
    fill: "#2fa8cc",
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26,
    cy: 26,
    fill: "#2c3e50",
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 28.5,
    cy: 22.5,
    fill: "#ecf0f1",
    r: 2.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.6d8f15762e1a7ca27de1002a4e2cbba9.svg";
export { ForwardRef as ReactComponent };